





















import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { DocumentAttributes } from "../../../../../domain/document";
import { ModelEditableMixin, TabContainableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../../../../document/editor";
import { DocumentStructureEditableMixin } from "../../../../document/editor/mixins";
import TabSelector from "../../../../system/selectors/TabSelector.vue";
import EntityViewer from "./object/EntityViewer.vue";

@Component({
  components: {
    TabSelector,
    EntityViewer,
  }
})
export default class AttributesDebugger extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, TabContainableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    entity: {
      name: "entity",
      description: "フロントエンドで扱うエンティティ。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly entityTab: any = AttributesDebugger.Tabs.entity;

  editingSource: EditingDocument;

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.entityTab,
    ];
    const selectedTab = Enumerable.from(this.tabs)
      .firstOrDefault(t => t === this.selectedTab);
    this.selectedTab = selectedTab
      ? selectedTab
      : this.tabs[0];
  }

  get source(): DocumentAttributes {
    return this.readPropertyOrDefault(s => s.attributes, null);
  }
}
